import edap from '@homeaway/edap-wrapper';

// EDAP EVENTS
export const CURRENCY_SELECTOR_PRESENTED = 'display_currency_selector.presented';
export const CURRENCY_SELECTOR_SELECTED = 'display_currency_selector_details.selected';
export const CURRENCY_SET_PRESENTED = 'display_currency_set.presented';
export const CURRENCY_SELECTED = 'display_currency.selected';
export const CURRENCY_UPDATED = 'display_currency.updated';
export const ALL_CURRENCY_SELECTED = 'display_currency_set.selected';


// ACTION LOCATIONS
export const LOCATION_HEADER = 'header_displaycurrency';
export const LOCATION_TOP_CURRENCY_VIEW = 'header_top_displaycurrency_list';
export const LOCATION_ALL_CURRENCY_VIEW = 'all_displaycurrency_set_modal';

export const triggerEdap = (name, data) => {
    edap().push({
        name,
        data
    });
};

export const triggerCurrencySelectorPresented = (displayCurrency) => {
    triggerEdap(CURRENCY_SELECTOR_PRESENTED, {
        action_location: LOCATION_HEADER,
        displaycurrency: displayCurrency
    });
};

export const triggerCurrencySelectorSelected = (displayCurrency) => {
    triggerEdap(CURRENCY_SELECTOR_SELECTED, {
        action_location: LOCATION_HEADER,
        displaycurrency: displayCurrency
    });
};

export const triggerTopCurrencyPresented = (topCurrencies, displayCurrency) => {
    triggerEdap(CURRENCY_SET_PRESENTED, {
        action_location: LOCATION_TOP_CURRENCY_VIEW,
        topdisplaycurrencies: topCurrencies,
        set_type: 'TOP',
        displaycurrency: displayCurrency
    });
};

export const triggerTopCurrencySelected = (currencyCode, displayCurrency) => {
    triggerEdap(CURRENCY_SELECTED, {
        action_location: LOCATION_TOP_CURRENCY_VIEW,
        selected_display_currency: currencyCode,
        displaycurrency: displayCurrency
    });

    triggerEdap(CURRENCY_UPDATED, {
        action_location: LOCATION_TOP_CURRENCY_VIEW,
        selected_display_currency: currencyCode,
        displaycurrency: displayCurrency
    });
};

export const triggerViewAllCurrencySelected = (displayCurrency) => {
    triggerEdap(ALL_CURRENCY_SELECTED, {
        action_location: LOCATION_TOP_CURRENCY_VIEW,
        set_type: 'ALL',
        displaycurrency: displayCurrency
    });
};

export const triggerAllCurrencySelected = (currencyCode, displayCurrency) => {
    triggerEdap(CURRENCY_SELECTED, {
        action_location: LOCATION_ALL_CURRENCY_VIEW,
        selected_display_currency: currencyCode,
        displaycurrency: displayCurrency
    });

    triggerEdap(CURRENCY_UPDATED, {
        action_location: LOCATION_ALL_CURRENCY_VIEW,
        selected_display_currency: currencyCode,
        displaycurrency: displayCurrency
    });
};

export const triggerAllCurrencyPresented = (displayCurrency) => {
    triggerEdap(CURRENCY_SET_PRESENTED, {
        action_location: LOCATION_ALL_CURRENCY_VIEW,
        set_type: 'ALL',
        displaycurrency: displayCurrency
    });
};